module.exports = __webpack_public_path__ + "img/Corner Bakery.4030d899.png";